import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteMaintenance } from '../Api'

export default generateApiAction({
  baseType: Types.MAINTENANCES.DELETE,
  api: deleteMaintenance,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/maintenances/DeleteAction.js